var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "q-modal",
        {
          attrs: {
            "content-css": {
              minWidth: _vm.getMinWidth,
              maxWidth: _vm.getMaxWidth,
              minHeight: "60vh"
            },
            "no-backdrop-dismiss": "",
            "no-esc-dismiss": ""
          },
          on: {
            hide: function($event) {
              return _vm.hideQuestionModal()
            }
          },
          model: {
            value: _vm.import_test,
            callback: function($$v) {
              _vm.import_test = $$v
            },
            expression: "import_test"
          }
        },
        [
          _c(
            "q-modal-layout",
            [
              _c(
                "q-toolbar",
                { attrs: { slot: "header" }, slot: "header" },
                [
                  _c("q-btn", {
                    attrs: {
                      flat: "",
                      round: "",
                      dense: "",
                      icon: "fas fa-times"
                    },
                    on: {
                      click: function($event) {
                        return _vm.hideQuestionModal()
                      }
                    }
                  }),
                  _c("q-toolbar-title", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$t("import_test")) +
                        "\n            "
                    )
                  ])
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "q-mt-sm q-pa-md" },
                [
                  _c(
                    "div",
                    { staticClass: "q-display-1 q-mb-md text-secondary" },
                    [
                      _c("q-icon", {
                        staticClass: "q-mb-sm",
                        attrs: { name: "fas fa-file-upload" }
                      }),
                      _vm._v(" " + _vm._s(_vm.$t("import")) + "\n            ")
                    ],
                    1
                  ),
                  _c("div", { staticClass: "row gutter-sm q-mt-sm" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c(
                        "div",
                        { staticClass: "col-12" },
                        [
                          _c("span", { staticClass: "q-pr-sm" }, [
                            _vm._v(_vm._s(_vm.$t("import_test_template")))
                          ]),
                          _c("q-btn", {
                            attrs: {
                              size: "xl",
                              flat: "",
                              round: "",
                              color: "positive",
                              icon: "far fa-file-alt"
                            },
                            on: {
                              click: function($event) {
                                return _vm.generateTemplate(1)
                              }
                            }
                          })
                        ],
                        1
                      ),
                      _c("div", { staticClass: "row gutter-sm" }, [
                        _c(
                          "div",
                          { staticClass: "col-11" },
                          [
                            _c("p", { staticClass: "caption" }, [
                              _vm._v(_vm._s(_vm.$t("file")))
                            ]),
                            _c("uploader", {
                              attrs: {
                                content_type: "",
                                multiple: false,
                                error: _vm.$v.file_url.$error
                              },
                              on: { fileUploaded: _vm.fileUploaded }
                            }),
                            _vm.file_url
                              ? _c(
                                  "p",
                                  { staticClass: "q-mt-md file-url" },
                                  [
                                    _c("q-icon", {
                                      attrs: {
                                        name: "fas fa-check",
                                        color: "positive"
                                      }
                                    }),
                                    _c(
                                      "a",
                                      {
                                        attrs: {
                                          href: _vm.file_url,
                                          target: "_blank"
                                        }
                                      },
                                      [
                                        _vm._v(
                                          " " +
                                            _vm._s(
                                              _vm.$truncateLink(_vm.file_url)
                                            )
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      ])
                    ])
                  ]),
                  _vm.imported_test.length > 0
                    ? _c("q-table", {
                        staticClass: "q-mt-lg",
                        attrs: {
                          data: _vm.imported_test,
                          columns: _vm.columns,
                          loading: _vm.loading,
                          "row-key": "id",
                          "no-data-label": _vm.$t("no_data_avaliable"),
                          "no-results-label": _vm.$t("no_results_found"),
                          "loading-label": _vm.$t("loading_data"),
                          "rows-per-page-label": _vm.$t("items_per_page"),
                          "rows-per-page-options": [0],
                          "binary-state-sort": ""
                        },
                        scopedSlots: _vm._u(
                          [
                            {
                              key: "top",
                              fn: function(props) {
                                return [
                                  _c("div", { staticClass: "q-table-title" }, [
                                    _vm._v(_vm._s(_vm.$t("test")))
                                  ]),
                                  _c("div", { staticClass: "col" })
                                ]
                              }
                            },
                            {
                              key: "header",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  _vm._l(props.cols, function(col) {
                                    return _c(
                                      "q-th",
                                      {
                                        key: col.name,
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                    " +
                                            _vm._s(_vm.$t(col.label)) +
                                            "\n                    "
                                        )
                                      ]
                                    )
                                  }),
                                  1
                                )
                              }
                            },
                            {
                              key: "body",
                              fn: function(props) {
                                return _c(
                                  "q-tr",
                                  { attrs: { props: props } },
                                  [
                                    _c(
                                      "q-td",
                                      {
                                        key: "id",
                                        attrs: {
                                          "auto-width": "",
                                          props: props
                                        }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(props.row.id) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "question",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(
                                              props.row.question
                                                ? props.row.question.substring(
                                                    0,
                                                    100
                                                  )
                                                : ""
                                            ) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "qty_answers",
                                        attrs: { props: props }
                                      },
                                      [
                                        _vm._v(
                                          "\n                        " +
                                            _vm._s(props.row.qty_answers) +
                                            "\n                    "
                                        )
                                      ]
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "status",
                                        attrs: {
                                          "auto-width": "",
                                          props: props
                                        }
                                      },
                                      [
                                        _c(
                                          "q-chip",
                                          {
                                            staticClass: "full-width",
                                            attrs: {
                                              small: "",
                                              icon: _vm.getIconStatus(
                                                props.row.status
                                              ),
                                              color: _vm.getColorStatus(
                                                props.row.status
                                              )
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                            " +
                                                _vm._s(
                                                  _vm.$t(
                                                    _vm.getStatus(
                                                      props.row.status
                                                    )
                                                  )
                                                ) +
                                                "\n                        "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _c(
                                      "q-td",
                                      {
                                        key: "actions",
                                        attrs: {
                                          "auto-width": "",
                                          props: props
                                        }
                                      },
                                      [
                                        _c("q-btn", {
                                          attrs: {
                                            flat: "",
                                            round: "",
                                            color: "primary",
                                            icon: "fas fa-clipboard-check"
                                          },
                                          on: {
                                            click: function($event) {
                                              return _vm.showTestDetails()
                                            }
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              }
                            }
                          ],
                          null,
                          false,
                          2967536590
                        )
                      })
                    : _vm._e(),
                  _c("div", { staticClass: "row gutter-sm q-mt-lg q-mr-md" }, [
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-4",
                        class: _vm.getOrder("cancel")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "tertiary",
                            label: _vm.$t("cancel"),
                            icon: "fas fa-ban"
                          },
                          on: {
                            click: function($event) {
                              return _vm.hideQuestionModal()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "col-xs-12 col-sm-4",
                        class: _vm.getOrder("save")
                      },
                      [
                        _c("q-btn", {
                          staticClass: "full-width",
                          attrs: {
                            color: "primary",
                            disabled: !_vm.file_url.length,
                            label: _vm.$t("upload_test"),
                            icon: "fas fa-upload"
                          },
                          on: {
                            click: function($event) {
                              return _vm.saveData()
                            }
                          }
                        })
                      ],
                      1
                    ),
                    _vm.file_url_complete && _vm.imported_test.length
                      ? _c(
                          "div",
                          {
                            staticClass: "col-xs-12 col-sm-4",
                            class: _vm.getOrder("save")
                          },
                          [
                            _c("q-btn", {
                              staticClass: "full-width",
                              attrs: {
                                color: "primary",
                                label: _vm.$t("save"),
                                icon: "far fa-save"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.saveImportedTest()
                                }
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm.show_test
        ? _c(
            "q-modal",
            {
              attrs: {
                "content-css": {
                  minWidth: _vm.getMinWidth,
                  maxWidth: _vm.getMaxWidth,
                  minHeight: "60vh"
                }
              },
              model: {
                value: _vm.show_test,
                callback: function($$v) {
                  _vm.show_test = $$v
                },
                expression: "show_test"
              }
            },
            [
              _c(
                "q-modal-layout",
                [
                  _c(
                    "q-toolbar",
                    { attrs: { slot: "header" }, slot: "header" },
                    [
                      _c("q-btn", {
                        attrs: {
                          flat: "",
                          round: "",
                          dense: "",
                          icon: "fas fa-times"
                        },
                        on: {
                          click: function($event) {
                            _vm.show_test = false
                          }
                        }
                      }),
                      _c("q-toolbar-title", [
                        _vm._v(
                          "\n                    " +
                            _vm._s(_vm.$t("imported_test")) +
                            "\n                "
                        )
                      ])
                    ],
                    1
                  ),
                  _c("div", { staticClass: "layout-padding" }, [
                    _c(
                      "div",
                      {
                        staticClass: "row gutter-sm justify-end question-list"
                      },
                      _vm._l(_vm.imported_test, function(question, index) {
                        return _c(
                          "div",
                          { key: index, staticClass: "col-xs-12 col-sm-12" },
                          [
                            _c(
                              "span",
                              { class: _vm.getQuestionClass(index, question) },
                              [
                                _vm._v(
                                  "\n                            " +
                                    _vm._s(index + 1) +
                                    ") "
                                ),
                                _c("span", {
                                  staticClass: "text-bold",
                                  domProps: {
                                    innerHTML: _vm._s(question.title)
                                  }
                                })
                              ]
                            ),
                            _vm._l(question.answers, function(answers, index) {
                              return _c(
                                "q-list",
                                {
                                  key: index,
                                  staticStyle: { border: "none" },
                                  attrs: { dense: "", padding: "" }
                                },
                                [
                                  _c(
                                    "q-item",
                                    [
                                      _c("q-icon", {
                                        staticClass: "q-mr-sm",
                                        attrs: {
                                          name: _vm.getAnswerIcon(
                                            answers.is_correct
                                          )
                                        }
                                      }),
                                      _c("span", {
                                        domProps: {
                                          innerHTML: _vm._s(answers.title)
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            })
                          ],
                          2
                        )
                      }),
                      0
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }